'use client'
import * as React from 'react'

interface AlbumContextProps {
  photoIds: string[]
}

const AlbumContext = React.createContext<AlbumContextProps | undefined>(undefined)

interface AlbumProviderProps extends React.PropsWithChildren {
  photoIds: string[]
}

export function AlbumProvider({ children, photoIds }: AlbumProviderProps) {
  return <AlbumContext.Provider value={{ photoIds }}>{children}</AlbumContext.Provider>
}

export const usePhotoIds = () => {
  const context = React.useContext(AlbumContext)
  if (!context) {
    // eslint-disable-next-line no-console
    console.error('usePhotoIds must be used within an AlbumProvider')
    return []
  }
  return context.photoIds
}
